import dynamic from 'next/dynamic'

export const DynamicHamburgerMenuDrawer = dynamic(
  () => import('.').then((mod) => mod.HamburgerMenuDrawer),
  { ssr: false },
)
